import { AvatarGroup as AvatarGroupBase } from "@mui/material";
import type { PropsWithChildren } from "react";

type Props = PropsWithChildren;

export const AvatarGroup = ({ children }: Props) => {
  return <AvatarGroupBase>{children}</AvatarGroupBase>;
};
